module.exports = __webpack_public_path__ + "img/0038.276c9260.jpg";